import {
  envApiUrl,
  envAppUrlWithoutSubdomain,
  envAppUrlWithSubdomain,
  envBackofficeRegisterUrl,
  envBackofficeUrl,
  envBaseUrl,
  envDemoUrl,
  envUserContentBucketUrl,
} from './environment-functions';
import { EnvironmentConfig } from '../config/api-config';

const baseDomain = 'dev.smallsalon.io';

export const environment: EnvironmentConfig = {
  production: false,
  i18nPath: 'assets/i18n',
  robotNoIndex: true,
  apiConfig: {
    apiName: 'smallsalon-http-api-endpoint',
    amplifyConfig: {
      Auth: {
        Cognito: {
          identityPoolId: 'eu-central-1:c865640f-5625-433e-97de-d4d0f14dd21b',
          userPoolId: 'eu-central-1_SYttptEEn',
          userPoolClientId: '4mocdvdlh1434m1nbheri5ov8d',
          allowGuestAccess: true,
          loginWith: {
            oauth: {
              domain: 'auth.dev.smallsalon.io',
              scopes: ['openid', 'email', 'profile'],
              redirectSignIn: [
                'http://localhost:4200',
                'https://admin.dev.smallsalon.io',
                'https://app.dev.smallsalon.io',
                'https://bo.dev.smallsalon.io',
              ],
              redirectSignOut: [
                'http://localhost:4200',
                'https://admin.dev.smallsalon.io',
                'https://app.dev.smallsalon.io',
                'https://bo.dev.smallsalon.io',
              ],
              responseType: 'code' as const,
              providers: ['Google', 'Apple'],
            },
          },
        },
      },
      API: {
        REST: {
          'smallsalon-http-api-endpoint': {
            endpoint: envApiUrl(baseDomain),
            region: 'eu-central-1',
          },
        },
      },
    },
  },
  urlConfig: {
    baseDomain,
    appUrlWithoutSubdomain: envAppUrlWithoutSubdomain(baseDomain),
    appUrlWithSubdomain: (subdomain: string | undefined) => envAppUrlWithSubdomain(subdomain, baseDomain),
    backofficeUrl: envBackofficeUrl(baseDomain),
    backofficeRegisterUrl: envBackofficeRegisterUrl(baseDomain),
    baseUrl: envBaseUrl(baseDomain),
    demoUrl: envDemoUrl(baseDomain),
    userContentBucketUrl: envUserContentBucketUrl(baseDomain),
  },
};
